import type { IEquipment, IEquipmentWithTranslation } from '../model/equipmentsList ';

export const getEquipmentsWithTranslation = (
  equipments: IEquipment[],
  translateField: (params: any) => any, //TODO: Remove 'any' once translateField is properly typed
): IEquipmentWithTranslation[] => {
  return equipments.map((equipment) => ({
    ...equipment,
    name:
      translateField({
        item: equipment,
        translatesField: 'equipment_translates',
        defaultField: 'equipment_name',
      }) || translateField({ item: equipment }),
    location_name:
      translateField({
        item: equipment,
        translatesField: 'location_translates',
        defaultField: 'location_name',
      }) ||
      translateField({ item: equipment.locationTable }) ||
      equipment.location_name,
    asset_code:
      translateField({
        item: equipment,
        field: 'asset_code',
        translatesField: 'equipment_translates',
      }) || translateField({ item: equipment, field: 'asset_code' }),
    originName: equipment.name,
    originLocationName: equipment.location_name,
    originAssetCode: equipment.asset_code,
  }));
};
